import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, TableBody } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import AddUserClientDialog from '../AddUserClientDialog';
import RemoveUserItemDialog from '../RemoveUserItemDialog';

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: theme.spacing(3),
  },
  grid: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(2.5),
  },
  sectionTitle: {
    borderBottom: '2px solid #DFDFDF',
    padding: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(2.5),
  },
}));

const headCells = [{ id: 'client', numeric: false, disablePadding: true, label: 'Client' }];

export default function UserClientTable({ user, deleteUserClient, setUserClient, data, access }) {
  const classes = useStyles();

  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [client, setClient] = useState(0);
  const handleClick = (_, clientIdx) => {
    setClient(clientIdx);
    // isSelected(clientName);
  };

  return (
    <>
      <Grid className={classes.grid} maxwidth="lg">
        <Paper>
          <Grid container spacing={0} direction="row" wrap="nowrap" justify="space-between">
            <Typography className={classes.sectionTitle} variant="h5" component="h3">
              Clients
            </Typography>
            {access.isInternal ? (
              <Button
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={() => {
                  setAddDialogOpen(true);
                }}
              >
                Edit
              </Button>
            ) : null}
          </Grid>
          <Container className={classes.wrapper} maxwidth="lg">
            <Table>
              <TableHead>
                <TableRow>
                  {headCells.map(headCell => (
                    <TableCell key={headCell.id} align={headCell.numeric ? 'right' : 'left'}>
                      {headCell.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {(user.clients || []).map((row, index) => (
                  <TableRow hover onClick={event => handleClick(event, index)} key={row.id}>
                    <TableCell>{row.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Container>
        </Paper>
      </Grid>
      {user && user.clients ? (
        <AddUserClientDialog
          title="Edit User Client(s)"
          description={`Select clients to associate with this user (${user.email})`}
          primaryButtonText="Save"
          userID={user.id}
          onPrimaryButtonClick={setUserClient}
          setAddDialogOpen={setAddDialogOpen}
          secondaryButtonText="Cancel"
          onSecondaryButtonClick={() => setAddDialogOpen(false)}
          open={addDialogOpen}
          onClose={() => setAddDialogOpen(false)}
          user={user}
          clients={data}
        />
      ) : null}
      <RemoveUserItemDialog
        title="Remove User from Client"
        description={`Do you want to remove user ${user.id} from client ${client}`}
        primaryButtonText="Remove"
        userID={user.id}
        selectedItem={client}
        onPrimaryButtonClick={deleteUserClient}
        secondaryButtonText="Cancel"
        onSecondaryButtonClick={() => setRemoveDialogOpen(false)}
        open={removeDialogOpen}
        onClose={() => setRemoveDialogOpen(false)}
      />
    </>
  );
}

UserClientTable.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string,
    createdAt: PropTypes.string,
    roles: PropTypes.shape({
      app: PropTypes.arrayOf(PropTypes.string),
    }),
    clients: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        billingAddressLine1: PropTypes.string,
        billingAddressLine2: PropTypes.string,
        billingAddressZip: PropTypes.string,
        billingAddressState: PropTypes.string,
        billingAddressCity: PropTypes.string,
      })
    ),
  }).isRequired,
  setUserClient: PropTypes.func.isRequired,
  deleteUserClient: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      billingAddressLine1: PropTypes.string,
      billingAddressLine2: PropTypes.string,
      billingAddressZip: PropTypes.string,
      billingAddressState: PropTypes.string,
      billingAddressCity: PropTypes.string,
    })
  ).isRequired,
  access: PropTypes.shape({
    isAdmin: PropTypes.bool,
    isInternal: PropTypes.bool,
  }).isRequired,
};
